import store from './store'

export const versionUpdated = () => {
  const version = store.getState().configs.version

  return !version || version !== process.env.REACT_APP_VERSION
}



// WEBPACK FOOTER //
// ./src/services/app.ts